'use client';
import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { reportError } from '@/lib/report-error';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(error, { boundary: 'root', digest: error.digest });
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h2 className="text-lg font-semibold">Something went wrong</h2>
      <p className="text-base text-muted-foreground">
        The error has been reported. Try again, or reload the page.
      </p>
      <Button onClick={reset}>Try again</Button>
    </div>
  );
}
